"use client";
import * as React from "react";
const SvgCalendarFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12.6 1.46h-.7V0h-1.4v1.46h-7V0H2.1v1.46h-.7C.63 1.46 0 2.1 0 2.9v11.64C0 15.35.63 16 1.4 16h11.2c.77 0 1.4-.65 1.4-1.45V2.9c0-.8-.63-1.46-1.4-1.46m0 13.1H1.4V5.08h11.2z" }));
export {
  SvgCalendarFilled as default
};
